import {
    createContext,
    type FC,
    type HTMLProps,
    type PropsWithChildren,
    useMemo,
} from "react";
import UUID from "../../../Utilities/Generic/UUID";

export const GridEditorContext = createContext<string | null>(null);

type Props = PropsWithChildren<Omit<HTMLProps<HTMLDivElement>, "id">>;

export const GridEditorBoundary: FC<Props> = ({ children, ...props }) => {
    const id = useMemo(() => {
        return `grid-boundary-${UUID.generate()}`;
    }, []);

    return (
        <GridEditorContext.Provider value={id}>
            <div id={id} {...props}>
                {children}
            </div>
        </GridEditorContext.Provider>
    );
};
